/*! movtech-sfx.js — Movtech gamifikációs hangkészlet
 *  Szintetizált (Web Audio API), licencmentes, fájl nélkül. On-brand UI-hangok.
 *  Használat:
 *    MovtechSFX.play('success');      // lejátszás
 *    MovtechSFX.enabled = false;      // némítás (pl. felhasználói kapcsoló)
 *    MovtechSFX.volume = 0.5;         // 0..1 mestervolumen
 *  Hangok: click, pop, page, whoosh, ding, coin, star, success, levelup, error
 *  A böngészők csak felhasználói interakció után engednek hangot — az első
 *  kattintásnál inicializálódik az AudioContext (ezt kezeli a könyvtár).
 */
(function (global) {
  var ctx = null, master = null;
  var API = { enabled: true, volume: 0.7 };

  function init() {
    if (ctx) { if (ctx.state === 'suspended') ctx.resume(); return; }
    var AC = global.AudioContext || global.webkitAudioContext;
    if (!AC) return;
    ctx = new AC();
    master = ctx.createGain();
    master.gain.value = API.volume;
    master.connect(ctx.destination);
  }
  // első interakciónál feloldjuk az audiót
  ['pointerdown', 'keydown', 'touchstart'].forEach(function (e) {
    global.addEventListener(e, init, { once: false, passive: true });
  });

  function now() { return ctx.currentTime; }

  // egy hangoló oszcillátor envelope-pal
  function tone(opts) {
    var t0 = opts.t0 != null ? opts.t0 : now();
    var osc = ctx.createOscillator();
    var g = ctx.createGain();
    osc.type = opts.type || 'sine';
    osc.frequency.setValueAtTime(opts.f0, t0);
    if (opts.f1 != null) osc.frequency.exponentialRampToValueAtTime(Math.max(1, opts.f1), t0 + opts.dur);
    var peak = (opts.gain != null ? opts.gain : 0.3);
    g.gain.setValueAtTime(0.0001, t0);
    g.gain.exponentialRampToValueAtTime(peak, t0 + (opts.attack || 0.005));
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + opts.dur);
    osc.connect(g); g.connect(master);
    osc.start(t0); osc.stop(t0 + opts.dur + 0.02);
  }

  // szűrt zaj (papír / swoosh)
  function noise(opts) {
    var t0 = opts.t0 != null ? opts.t0 : now();
    var dur = opts.dur;
    var buf = ctx.createBuffer(1, Math.ceil(ctx.sampleRate * dur), ctx.sampleRate);
    var data = buf.getChannelData(0);
    for (var i = 0; i < data.length; i++) data[i] = (Math.random() * 2 - 1);
    var src = ctx.createBufferSource(); src.buffer = buf;
    var bp = ctx.createBiquadFilter();
    bp.type = opts.filter || 'bandpass';
    bp.frequency.setValueAtTime(opts.f0, t0);
    if (opts.f1 != null) bp.frequency.linearRampToValueAtTime(opts.f1, t0 + dur);
    bp.Q.value = opts.q || 0.8;
    var g = ctx.createGain();
    g.gain.setValueAtTime(0.0001, t0);
    g.gain.exponentialRampToValueAtTime(opts.gain || 0.25, t0 + (opts.attack || 0.01));
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
    src.connect(bp); bp.connect(g); g.connect(master);
    src.start(t0); src.stop(t0 + dur + 0.02);
  }

  // hangjegy -> frekvencia (A4=440)
  function n(semitonesFromA4) { return 440 * Math.pow(2, semitonesFromA4 / 12); }

  var SOUNDS = {
    click: function () { tone({ type: 'triangle', f0: 1300, dur: 0.035, gain: 0.18 }); },
    pop:   function () { tone({ type: 'sine', f0: 380, f1: 920, dur: 0.11, gain: 0.32, attack: 0.004 }); },
    page:  function () { noise({ f0: 900, f1: 2600, dur: 0.18, gain: 0.16, q: 0.7, filter: 'bandpass' }); },
    whoosh:function () { noise({ f0: 250, f1: 1800, dur: 0.16, gain: 0.18, q: 0.6 });
                         noise({ t0: now() + 0.12, f0: 1800, f1: 350, dur: 0.18, gain: 0.14, q: 0.6 }); },
    ding:  function () { tone({ type: 'sine', f0: 1320, dur: 0.5, gain: 0.28, attack: 0.003 });
                         tone({ type: 'sine', f0: 1980, dur: 0.45, gain: 0.12, attack: 0.003 }); },
    coin:  function () { tone({ type: 'square', f0: n(3), dur: 0.07, gain: 0.16 });   // B5
                         tone({ type: 'square', t0: now() + 0.07, f0: n(8), dur: 0.24, gain: 0.16 }); }, // E6
    star:  function () { tone({ type: 'triangle', f0: n(10), dur: 0.12, gain: 0.24 });        // F#6
                         tone({ type: 'sine', t0: now() + 0.05, f0: n(22), dur: 0.18, gain: 0.10 }); },
    levelup: function () {
      var seq = [n(-9), n(-5), n(-2), n(3)], t = now();         // C5 E5 G5 B5
      seq.forEach(function (f, i) { tone({ type: 'square', t0: t + i * 0.08, f0: f, dur: 0.16, gain: 0.18 }); });
    },
    // FŐ GYŐZELMI HANG — sikeres rendelés (fanfár)
    success: function () {
      var t = now();
      var arp = [n(-9), n(-5), n(-2), n(3)];                    // C5 E5 G5 C6(≈B5+...) felfelé
      arp.forEach(function (f, i) {
        tone({ type: 'triangle', t0: t + i * 0.09, f0: f, dur: 0.22, gain: 0.26 });
        tone({ type: 'square',   t0: t + i * 0.09, f0: f * 2, dur: 0.16, gain: 0.06 });
      });
      // záró akkord
      var tc = t + arp.length * 0.09 + 0.02;
      [n(3), n(7), n(10), n(15)].forEach(function (f) {         // C6 E6 G6 C7 dúr
        tone({ type: 'triangle', t0: tc, f0: f, dur: 0.5, gain: 0.16, attack: 0.006 });
      });
      // csillám-réteg
      noise({ t0: tc, f0: 4000, f1: 9000, dur: 0.5, gain: 0.05, q: 0.5, filter: 'highpass' });
    },
    // TŰZIJÁTÉK — valósághű ÉS laptopon is jól hallható: süvítés → csattanás → recsegő-ropogás
    firework: function () {
      var t = now();
      // 1) felszálló süvítés (a rakéta emelkedése) — hallható közép-csúszás
      tone({ type: 'sawtooth', t0: t, f0: 520, f1: 1750, dur: 0.42, gain: 0.11, attack: 0.03 });
      noise({ t0: t, f0: 1200, f1: 3000, dur: 0.42, gain: 0.05, q: 0.8, filter: 'bandpass' });
      // 2) robbanás — közép „csattanás" (laptopon is szól) + dörej + mély thump
      var tb = t + 0.46;
      noise({ t0: tb, f0: 350, f1: 950, dur: 0.13, gain: 0.6, q: 0.6, filter: 'bandpass' });   // csattanás
      noise({ t0: tb, f0: 520, f1: 95, dur: 0.4, gain: 0.42, q: 0.5, filter: 'lowpass' });      // dörej
      tone({ type: 'sine', t0: tb, f0: 165, f1: 46, dur: 0.32, gain: 0.34, attack: 0.002 });    // sub thump
      // 3) recsegő-ropogó szikrák — hangos, közép-magas pukkanások ~1 mp-en át
      for (var i = 0; i < 30; i++) {
        var tc = tb + 0.03 + Math.random() * 1.0;
        var f = 1600 + Math.random() * 3600;
        noise({ t0: tc, f0: f, f1: f * 0.5, dur: 0.015 + Math.random() * 0.045,
                gain: 0.17 + Math.random() * 0.16, q: 4 + Math.random() * 6, filter: 'bandpass' });
      }
      // 4) sistergő csillám-farok
      noise({ t0: tb + 0.05, f0: 4200, f1: 9200, dur: 0.7, gain: 0.07, q: 0.5, filter: 'highpass' });
    },
    error: function () { tone({ type: 'sine', f0: 220, f1: 150, dur: 0.18, gain: 0.16, attack: 0.004 }); },
    // kassza „cha-ching” — fizetés / pénztár gomb
    cashRegister: function () {
      var t = now();
      noise({ t0: t, f0: 2600, dur: 0.05, gain: 0.10, q: 3, filter: 'bandpass' });          // mechanikus kattanás
      tone({ type: 'sine', t0: t + 0.04, f0: n(15), dur: 0.5, gain: 0.22, attack: 0.003 });  // „cha”
      tone({ type: 'sine', t0: t + 0.04, f0: n(15) * 2.4, dur: 0.4, gain: 0.07 });
      tone({ type: 'sine', t0: t + 0.18, f0: n(19), dur: 0.6, gain: 0.24, attack: 0.003 });  // „ching”
      tone({ type: 'sine', t0: t + 0.18, f0: n(19) * 2.4, dur: 0.5, gain: 0.08 });
    },
    // kupon-jutalom jingle — értékes kupon / ajándék feloldva
    coupon: function () {
      var t = now(), arp = [n(3), n(7), n(10), n(15), n(19)];
      arp.forEach(function (f, i) { tone({ type: 'triangle', t0: t + i * 0.075, f0: f, dur: 0.28, gain: 0.17 }); });
      noise({ t0: t + 0.4, f0: 5000, f1: 9000, dur: 0.45, gain: 0.05, q: 0.5, filter: 'highpass' });
    },
    // értesítő ding-dong — feliratkozás / üzenet / visszajelzés
    notify: function () {
      var t = now();
      tone({ type: 'sine', t0: t, f0: n(9), dur: 0.4, gain: 0.22, attack: 0.003 });
      tone({ type: 'sine', t0: t, f0: n(9) * 2, dur: 0.3, gain: 0.07 });
      tone({ type: 'sine', t0: t + 0.17, f0: n(4), dur: 0.55, gain: 0.22, attack: 0.003 });
      tone({ type: 'sine', t0: t + 0.17, f0: n(4) * 2, dur: 0.4, gain: 0.07 });
    },
    // power-up — küszöb elérve / szintlépés (emelkedő arpeggio)
    powerup: function () {
      var t = now();
      [n(-9), n(-5), n(-2), n(3), n(8), n(12)].forEach(function (f, i) {
        tone({ type: 'square', t0: t + i * 0.05, f0: f, dur: 0.14, gain: 0.13 });
      });
    }
  };

  API.play = function (name) {
    if (!API.enabled) return;
    init();
    if (!ctx) return;
    if (ctx.state === 'suspended') ctx.resume();
    if (master) master.gain.value = API.volume;
    var fn = SOUNDS[name];
    if (fn) try { fn(); } catch (e) { /* csendben */ }
  };
  API.list = function () { return Object.keys(SOUNDS); };

  global.MovtechSFX = API;
})(typeof window !== 'undefined' ? window : this);
